import { render, staticRenderFns } from "./SubscriptionPlanForm.vue?vue&type=template&id=2a82dbd2"
import script from "./SubscriptionPlanForm.vue?vue&type=script&lang=js"
export * from "./SubscriptionPlanForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports